import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { MOCKUP_URL, buyers } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutes, setMinutes] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let showTimer: number;
    const show = () => {
      setMinutes(1 + Math.floor(Math.random() * 9));
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        showTimer = window.setTimeout(() => {
          setIndex(i => (i + 1) % buyers.length);
          show();
        }, GAP);
      }, VISIBLE_FOR);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-28 sm:left-6 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-40" data-mp="116miqyxel085">
      <AnimatePresence data-id="element-41" data-mp="1aw6205p12w3j">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_20px_40px_-12px_rgba(6,23,34,0.45)] ring-1 ring-navy-900/10" data-id="element-42" data-mp="1aysgkpac6bv9">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-mist object-contain" data-id="element-43" data-mp="28iwmyrvc34rt" />
            <div className="min-w-0" data-id="element-44" data-mp="23kv86j4xxrm5">
              <p className="text-sm font-bold text-navy-900" data-id="element-45" data-mp="2aol3ubat2827">
                {buyer.name} from {buyer.country}
              </p>
              <p className="text-[13px] leading-snug text-ink/70" data-id="element-46" data-mp="2fmmov1rskhgb">just purchased the Laser Complications Decision Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-accent-600" data-id="element-47" data-mp="2knahfrvo56cn">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="2pl2h582k1wre" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/40 transition-colors duration-150 hover:text-ink/70" aria-label="Dismiss notification" data-id="element-49" data-mp="1wwd9eq6zut6o">
              <XIcon className="h-4 w-4" data-id="element-50" data-mp="1983wkdrrdfro" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}